var _excluded = ["links"];
var _jsxFileName = "/repo/packages/webassets/src/components/ClientError/Links/index.tsx",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import React from 'react';
import { t, defineMessages } from '@sm/intl';
import useStyles from './useStyles';
var COPY = defineMessages({
  HOME: {
    id: 'Links.home',
    defaultMessage: 'Home',
    description: '[Type: Label][Vis.: med] - Home link in Error Message'
  },
  SITEMAP: {
    id: 'Links.sitemap',
    defaultMessage: 'Sitemap',
    description: '[Type: Label][Vis.: med] - Sitemap link in Error Message'
  },
  HELP_CENTER: {
    id: 'Links.helpCenter',
    defaultMessage: 'Help Center',
    description: '[Type: Label][Vis.: med] - Help Center link in Error Message'
  },
  TEMPLATES: {
    id: 'Links.templates',
    defaultMessage: 'Templates',
    description: '[Type: Label][Vis.: med] - Templates link in Error Message'
  },
  LEARN_MORE: {
    id: 'Links.learnMore',
    defaultMessage: 'Learn More',
    description: '[Type: Label][Vis.: med] - Learn More link in 404 Error Message'
  }
});
var defaultLinks = [{
  href: '/',
  label: t(COPY.HOME)
}, {
  href: '/mp/sitemap/',
  label: t(COPY.SITEMAP)
}, {
  href: 'https://help.surveymonkey.com/',
  label: t(COPY.HELP_CENTER)
}, {
  href: '/mp/survey-templates/',
  label: t(COPY.TEMPLATES)
}, {
  href: '/mp/take-a-tour/',
  label: t(COPY.LEARN_MORE)
}];
var Links = function Links(_ref) {
  var _ref$links = _ref.links,
    links = _ref$links === void 0 ? defaultLinks : _ref$links,
    containerBoxProps = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    linkList = _useStyles.linkList,
    linkStyles = _useStyles.linkItem,
    linkAnchor = _useStyles.linkAnchor;
  return /*#__PURE__*/React.createElement(Box, Object.assign({}, containerBoxProps, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    variant: "bodySm",
    align: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("nav", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("ul", {
    className: linkList,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 11
    }
  }, links.map(function (link) {
    return /*#__PURE__*/React.createElement("li", {
      className: linkStyles,
      key: link.label,
      "data-testid": "ClientError_Link",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 79,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement("a", {
      className: linkAnchor,
      href: link.href,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 17
      }
    }, link.label));
  })))));
};
export default Links;
//# sourceMappingURL=index.js.map